import React, { FC } from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

import { IHierarchicalDepartmentDTO } from 'src/api/dtos';
import { Tooltip } from 'src/shared/components';
import { formatDepartmentDisplay } from 'src/shared/utils';

interface Props {
  department: IHierarchicalDepartmentDTO;
  checked: boolean;
  indeterminate: boolean;
}

export const MultiDepartmentSelectorOption: FC<Props> = ({ department, checked, indeterminate }) => {
  const label = formatDepartmentDisplay(department.description, department.number);

  return (
    <Tooltip title={label} placement="left" showIcon={false}>
      <FormControlLabel
        control={<Checkbox size="small" checked={checked} indeterminate={indeterminate} />}
        label={label}
        sx={{
          width: '100%',
          '.MuiFormControlLabel-label': {
            fontSize: '0.875rem',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          },
        }}
      />
    </Tooltip>
  );
};
